<template>
  <div>
    <List>
      <div v-for="(event, index) in events"
        class="item"
        :class="styleEnded(event)"
        :key="index"
        @click="showEvent(event)">

        <div clas="cell-left">
          {{ event.get('name') }}
        </div>
        <div clas="cell-left">
          {{ eventDate(event) }}
        </div>
      </div>
    </List>
  </div>
</template>

<script>
import { format } from 'date-fns'
import MixinLocale from '@/components/MixinLocale'
import List from '@/components/List'
import Parse from 'parse'

export default {
  mixins: [
    MixinLocale
  ],

  components: {
    List
  },

  created: async function () {
    let query = new Parse.Query('Event')
    query.descending('date')
    this.events = await query.find()
  },

  data () {
    return {
      events: []
    }
  },

  methods: {
    showEvent: function (event) {
      this.$store.commit('event/setSelected', event, { root: true })
      this.$router.push({
        name: 'event-content',
        params: { id: event.id }
      })
    },

    eventDate: function (event) {
      let style = (this.locale === 'en') ? 'MMM D' : 'M月D日'
      return format(event.get('date'), style)
    },

    styleEnded: function (event) {
      if (this.$store.getters['event/hasFinished'](event)) {
        return { finished: true }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.finished {
  color: gray;
  text-decoration: line-through;
}
</style>
